/* eslint-disable max-len */
import React from 'react';

export function BuildWorkflow(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="none" viewBox="0 0 64 64" {...props}>
      <g clipPath="url(#clip0_1481_2380)">
        <mask
          id="mask0_1481_2380"
          style={{ maskType: 'luminance' }}
          width="64"
          height="65"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
        >
          <path fill="#fff" d="M64 .001H0v64h64v-64z"></path>
        </mask>
        <g mask="url(#mask0_1481_2380)">
          <path
            fill="#525266"
            d="M32 64.001c17.673 0 32-14.327 32-32 0-17.673-14.327-32-32-32-17.673 0-32 14.327-32 32 0 17.673 14.327 32 32 32z"
          ></path>
          <path
            fill="url(#paint0_linear_1481_2380)"
            d="M49.372 35.329c-.8.043-1.407-.76-1.14-1.529a9.91 9.91 0 00.541-3.396c-.044-3.08-2.65-5.25-6.02-4.559-3.342.686-3.97 3.688-3.483 5.102.254.739 1.138 1.997 1.926 3.033.551.725.09 1.782-.796 1.83l-8.927.478-.468-7.874c-.039-.66-.756-1.017-1.266-.629-.859.653-2.217 1.236-4.141.824-3.658-.784-3.671-4.254-3.068-6 .51-1.475 3.934-3.42 6.551-1.694.556.366 1.278-.075 1.237-.765l-.496-9.938C18.699 11.277 10 20.625 10 32c0 1.264.109 2.502.315 3.708l8.544.101c.386.008.58.426.323.688-.493.5-.98 1.317-.892 2.556.172 2.421 2.363 3.34 4.784 2.32 2.411-1.018 3.041-3.728.659-5.623l7.671.154.051 6.008c.006.658.807 1.069 1.387.705 2.963-1.857 5.777.408 5.924 2.193.17 2.073-.991 4.134-3.54 3.884a7.755 7.755 0 01-2.64-.733c-.594-.289-1.284.106-1.279.727l.042 5.194c.198.005.395.008.594.008 11.064 0 20.214-8.17 21.723-18.793l-4.294.23z"
          ></path>
          <path
            fill="url(#paint1_linear_1481_2380)"
            d="M32.586 47.97a7.757 7.757 0 002.639.732c2.55.25 3.711-1.81 3.54-3.884-.146-1.785-2.96-4.05-5.924-2.192-.58.363-1.38-.048-1.386-.706l-.051-6.008-7.671-.154c2.382 1.895 1.752 4.605-.66 5.622-2.42 1.022-4.61.102-4.784-2.32-.088-1.238.4-2.054.892-2.555.258-.262.063-.68-.323-.688l-8.543-.101C12.048 45.85 20.764 53.61 31.349 53.89l-.043-5.193c-.005-.622.686-1.017 1.28-.728z"
          ></path>
          <path
            fill="url(#paint2_linear_1481_2380)"
            d="M31.35 54.002h-.003c-10.488-.278-19.38-7.96-21.142-18.268a.112.112 0 01.025-.092.11.11 0 01.087-.04l8.544.102c.234.005.43.134.514.337a.496.496 0 01-.112.542c-.44.448-.947 1.24-.86 2.47.072 1.004.497 1.772 1.229 2.22.884.54 2.123.542 3.399.003 1.15-.485 1.922-1.397 2.066-2.44.148-1.075-.36-2.138-1.433-2.99a.112.112 0 01.07-.2h.002l7.672.153c.06 0 .11.05.11.111l.051 6.008c.002.258.15.492.396.626a.81.81 0 00.818-.014c1.805-1.132 3.342-.668 4.098-.29 1.115.556 1.918 1.589 1.998 2.569.103 1.254-.281 2.441-1.029 3.175-.659.647-1.57.934-2.635.83a7.854 7.854 0 01-2.677-.745.808.808 0 00-.788.036.68.68 0 00-.33.59l.043 5.193a.114.114 0 01-.113.114zm-20.9-18.173c1.792 10.097 10.502 17.618 20.787 17.944l-.042-5.076a.912.912 0 01.434-.781c.302-.19.679-.208 1.008-.048a7.628 7.628 0 002.6.722c.996.097 1.845-.168 2.456-.767.7-.687 1.06-1.807.962-2.996-.073-.89-.844-1.872-1.875-2.387-.714-.356-2.166-.793-3.877.28a1.036 1.036 0 01-1.046.02.944.944 0 01-.513-.82l-.05-5.899-7.245-.145c.969.867 1.419 1.92 1.271 2.99-.154 1.122-.977 2.1-2.202 2.617-1.343.567-2.657.56-3.604-.02-.785-.48-1.26-1.33-1.335-2.395-.094-1.313.45-2.162.924-2.642a.271.271 0 00.063-.3.329.329 0 00-.308-.197l-8.408-.1z"
          ></path>
          <path
            fill="url(#paint3_linear_1481_2380)"
            d="M29.08 20.92c-2.617-1.726-6.041.22-6.55 1.692-.603 1.747-.59 5.217 3.067 6.001 1.925.413 3.283-.17 4.142-.824.51-.388 1.227-.031 1.266.63l.467 7.874 8.927-.479c.886-.047 1.348-1.105.797-1.83-.788-1.036-1.672-2.294-1.927-3.033-.487-1.414.142-4.416 3.483-5.102 3.371-.691 5.976 1.48 6.021 4.559a9.915 9.915 0 01-.541 3.396c-.268.77.339 1.572 1.14 1.53l4.293-.231c.144-1.012.22-2.046.22-3.098 0-9.809-6.467-18.11-15.379-20.894l-.026.006-.06-.033a21.98 21.98 0 00-8.599-.867l.497 9.937c.04.69-.682 1.131-1.237.765z"
          ></path>
          <path
            fill="url(#paint4_linear_1481_2380)"
            d="M31.473 36.404a.112.112 0 01-.113-.106l-.467-7.874a.716.716 0 00-.414-.623.649.649 0 00-.671.077c-.82.623-2.22 1.276-4.234.844-1.34-.288-2.312-.949-2.887-1.966-.783-1.383-.63-3.117-.263-4.181.288-.835 1.389-1.722 2.677-2.159.844-.286 2.492-.614 4.043.409.216.142.479.15.702.022a.734.734 0 00.36-.687l-.497-9.939a.113.113 0 01.102-.117 22.107 22.107 0 018.663.881l.024.013c.014 0 .028 0 .042.005a22.112 22.112 0 0111.088 7.853 21.785 21.785 0 014.37 13.148c0 1.034-.075 2.082-.221 3.114a.112.112 0 01-.106.096l-4.293.23a1.251 1.251 0 01-1.064-.5 1.262 1.262 0 01-.188-1.177 9.77 9.77 0 00.535-3.359c-.021-1.454-.616-2.722-1.675-3.57-1.117-.895-2.612-1.208-4.211-.88-1.72.353-2.583 1.306-3.004 2.043-.603 1.054-.633 2.222-.395 2.913.203.587.863 1.625 1.91 3.002.287.377.341.879.142 1.309a1.185 1.185 0 01-1.022.7l-8.928.479h-.006zm-1.267-8.889a.88.88 0 01.367.081.95.95 0 01.545.815l.46 7.763 8.816-.473a.963.963 0 00.83-.57c.164-.355.12-.768-.118-1.08-1.076-1.414-1.73-2.445-1.943-3.064-.254-.738-.225-1.982.412-3.097.445-.777 1.353-1.782 3.155-2.151 1.665-.342 3.227-.014 4.397.924 1.112.891 1.737 2.22 1.76 3.743a9.994 9.994 0 01-.548 3.434c-.114.327-.056.689.155.968.208.276.534.43.871.412l4.201-.225c.137-.992.206-1.998.206-2.99 0-9.566-6.135-17.912-15.27-20.779l-.012.002a.112.112 0 01-.064-.013l-.05-.027a21.882 21.882 0 00-8.437-.87l.491 9.83a.955.955 0 01-.471.894.88.88 0 01-.94-.03c-1.47-.97-3.041-.656-3.846-.383-1.207.41-2.273 1.258-2.536 2.019-.353 1.02-.5 2.68.246 3.998.542.958 1.463 1.583 2.739 1.856 1.929.413 3.267-.208 4.049-.803a.881.881 0 01.535-.184z"
          ></path>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1481_2380"
          x1="32.889"
          x2="30.443"
          y1="49.014"
          y2="10.3"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9A9B9"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_1481_2380"
          x1="24.548"
          x2="24.548"
          y1="35.716"
          y2="53.89"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#73738F"></stop>
          <stop offset="1" stopColor="#21212D"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_1481_2380"
          x1="24.549"
          x2="24.549"
          y1="35.603"
          y2="54.002"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#73738F"></stop>
          <stop offset="1" stopColor="#21212D"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_1481_2380"
          x1="22.234"
          x2="53.885"
          y1="23.203"
          y2="23.203"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DD2476"></stop>
          <stop offset="1" stopColor="#FF512F"></stop>
        </linearGradient>
        <linearGradient
          id="paint4_linear_1481_2380"
          x1="22.123"
          x2="53.998"
          y1="23.203"
          y2="23.203"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DD2476"></stop>
          <stop offset="1" stopColor="#FF512F"></stop>
        </linearGradient>
        <clipPath id="clip0_1481_2380">
          <path fill="#fff" d="M0 0H64V64H0z" transform="translate(0 .001)"></path>
        </clipPath>
      </defs>
    </svg>
  );
}
